webpackJsonp([10],{

/***/ "7Spq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbab3e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("R7cA");
function injectStyle (ssrContext) {
  __webpack_require__("7Spq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbab3e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fullstory_browser__ = __webpack_require__("K4wX");







__WEBPACK_IMPORTED_MODULE_5__fullstory_browser__["init"]({ orgId: 'X1XZ9' });
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$FullStory = __WEBPACK_IMPORTED_MODULE_5__fullstory_browser__;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var server = Object({"NODE_ENV":"production"}).SERVER || '';

var loadPage = function loadPage() {
  return new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]);
    }
  });
};

if (__WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('token')) {
  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(server + '/token', {
    token: __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('token')
  }, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (response) {
    if (response.data.status !== 'Success') {
      // If invalid token, redirect to login
      window.location.href = '/login';
    } else {
      if (window.location.pathname === '/login') {
        // Automatically redirect authorized user away from /login
        window.location.href = response.data.views[0].link;
      } else if (response.data.views.map(function (view) {
        return view.link;
      }).indexOf(window.location.pathname) === -1) {
        // User not authorized to view page
        // Redirect user to an authorized page
        window.location.href = response.data.views[0].link;
      } else {
        loadPage();
      }
    }
  }).catch(function (error) {
    console.log(error);
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    } else {
      loadPage();
    }
  });
} else {
  // Redirect to login page
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  } else {
    loadPage();
  }
}

/***/ }),

/***/ "R7cA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{beta: _vm.beta},attrs:{"id":"app"}},[(!_vm.isLoginPage)?_c('div',{staticClass:"ui attached menu",attrs:{"id":"top"}},[_c('div',{staticClass:"ui container"},[_vm._l((_vm.views),function(view){return _c('a',{staticClass:"item",attrs:{"href":view.link}},[_vm._v("\n        "+_vm._s(view.label)+"\n      ")])}),_vm._v(" "),_c('a',{staticClass:"right item"},[_vm._v("\n        Credits used: "+_vm._s(_vm.creditsUsed)+" / "+_vm._s(_vm.creditsTotal)+"\n      ")]),_vm._v(" "),_c('a',{staticClass:"item",on:{"click":_vm.logout}},[_vm._v("\n        Logout\n      ")])],2)]):_vm._e(),_vm._v(" "),_c('alert-view',{attrs:{"visible":this.showAlert,"header":_vm.alertHeader,"message":_vm.alertMessage,"update-visibility":_vm.updateAlertVisibility}}),_vm._v(" "),_c('router-view',{attrs:{"show-product-tags":_vm.showProductTags,"update-credit":_vm.updateCredit,"should-disable-submit-btn":_vm.shouldDisableSubmitBtn}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");



var routerOptions = [{ path: '/', component: 'Demo' }, { path: '/admin', component: 'Admin' }, { path: '/login', component: 'Login' }, { path: '/describe', component: 'Describe' }, { path: '/freeflow', component: 'Freeflow' }, { path: '/blog', component: 'Blog' }, { path: '*', component: 'NotFound' }];
var routes = routerOptions.map(function (route) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, route, {
    component: function component() {
      return __webpack_require__("mUJ2")("./" + route.component + '.vue');
    }
  });
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: routes,
  mode: 'history'
}));

/***/ }),

/***/ "eAn8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"ui negative message"},[_c('i',{staticClass:"close icon",on:{"click":_vm.hide}}),_vm._v(" "),_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.message))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mUJ2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./About.vue": [
		"c27y",
		8
	],
	"./Admin.vue": [
		"qbhH",
		0
	],
	"./Alert.vue": [
		"yL53"
	],
	"./BackToTop.vue": [
		"Luyq",
		6
	],
	"./Blog.vue": [
		"SGec",
		5
	],
	"./Demo.vue": [
		"26cW",
		2
	],
	"./Describe.vue": [
		"xAj5",
		4
	],
	"./Freeflow.vue": [
		"Tytv",
		3
	],
	"./Login.vue": [
		"xJsL",
		1
	],
	"./NotFound.vue": [
		"YcJa",
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "mUJ2";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Alert__ = __webpack_require__("yL53");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'alert-view': __WEBPACK_IMPORTED_MODULE_2__components_Alert__["default"]
  },
  mounted: function mounted() {
    var _this = this;

    if (__WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('token')) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.server + '/token', {
        token: __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('token')
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        _this.views = response.data.views;
        _this.beta = response.data.beta;
        _this.showProductTags = response.data.showProductTags;
      }).catch(function (error) {
        console.log(error);
        if (window.location.pathname !== '/login') window.location.href = '/login';
      });

      this.updateCredit();
    }
  },

  data: function data() {
    return {
      server: Object({"NODE_ENV":"production"}).SERVER || '',
      views: [],
      creditsLeft: '',
      creditsTotal: '',
      creditsUsed: '',
      showProductTags: false,
      beta: false,
      showAlert: false,
      alertHeader: '',
      alertMessage: ''
    };
  },
  computed: {
    isLoginPage: function isLoginPage() {
      return window.location.pathname === '/login';
    },
    shouldDisableSubmitBtn: function shouldDisableSubmitBtn() {
      return this.creditsLeft <= 0;
    }
  },
  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('token', 'token', { expires: 0 });
      window.location.href = '/login';
    },
    updateCredit: function updateCredit() {
      var _this2 = this;

      var creditPath = this.server + '/credits?token=' + __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(creditPath).then(function (response) {
        _this2.$FullStory.event('updateCredit', {
          creditsLeft: response.data.creditsLeft,
          creditsTotal: response.data.creditsTotal,
          creditsUsed: _this2.creditsTotal - _this2.creditsLeft
        });
        _this2.creditsLeft = response.data.creditsLeft;
        _this2.creditsTotal = response.data.creditsTotal;
        _this2.creditsUsed = _this2.creditsTotal - _this2.creditsLeft;
        if (_this2.creditsLeft <= 0) {
          _this2.alertHeader = 'Sorry!';
          _this2.alertMessage = 'You are out of credits, please email us at hello@hypotenuse.ai to top up your credits!';
          _this2.showAlert = true;
        }
      });
    },
    updateAlertVisibility: function updateAlertVisibility(newStatus) {
      this.showAlert = newStatus;
    }
  },
  name: 'app'
});

/***/ }),

/***/ "yL53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__("zvUr");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09b3aced_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__("eAn8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09b3aced_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "zvUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    header: String,
    message: String,
    visible: Boolean,
    'updateVisibility': Function
  },
  methods: {
    hide: function hide() {
      this.updateVisibility(false);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b245dd298227bc52b18a.js